import { render } from "./widget_rowValues2.vue?vue&type=template&id=246cf083&scoped=true"
import script from "./widget_rowValues2.vue?vue&type=script&lang=js"
export * from "./widget_rowValues2.vue?vue&type=script&lang=js"

import "./widget_rowValues2.vue?vue&type=style&index=0&id=246cf083&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-246cf083"]])

export default __exports__